import { render, staticRenderFns } from "./BackgroundJobs.vue?vue&type=template&id=be25d7de"
import script from "./BackgroundJobs.vue?vue&type=script&lang=js"
export * from "./BackgroundJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports